import { UPDATE_STATUS_RECEIVED, UPDATE_DIALOG_DISMISSED, UPDATE_DIALOG_REOPENED } from './update-actions';

const initialState = {
	state: 'idle',
	currentVersion: null,
	availableVersion: null,
	releaseNotes: null,
	progressPercent: null,
	error: null,
	canAutoInstall: null,
	dialogDismissed: false,
};

function update(state = initialState, action) {
	switch (action.type) {
		case UPDATE_STATUS_RECEIVED: {
			const isNewVersion = action.status.availableVersion
				&& action.status.availableVersion !== state.availableVersion;
			return {
				...state,
				...action.status,
				dialogDismissed: isNewVersion ? false : state.dialogDismissed,
			};
		}
		case UPDATE_DIALOG_DISMISSED:
			return { ...state, dialogDismissed: true };
		case UPDATE_DIALOG_REOPENED:
			return { ...state, dialogDismissed: false };
		default:
			return state;
	}
}

export default update;
